import { render } from "./PRTimeline.vue?vue&type=template&id=dfd216f0"
import script from "./PRTimeline.vue?vue&type=script&lang=js"
export * from "./PRTimeline.vue?vue&type=script&lang=js"

import "./PRTimeline.vue?vue&type=style&index=0&id=dfd216f0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__